import { bootstrapAuth } from "./me";
import { useAuthStore } from "@/stores/auth-store";

// Loader of the routes that answer both anonymous and signed-in visitors: settles the session state (and with it the
// anonymous CSRF token the public BFF endpoints require) without redirecting to the login.
export async function optionalAuth(): Promise<null> {
  if (useAuthStore.getState().status === "loading") await bootstrapAuth();
  return null;
}
